import React from "react";
import "../Component_styles/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-card">
      <div className="copyright-box">
        <div className="copy-text">
          Copyright © {currentYear}
        </div>

        <div className="copy-link">
          <a
            href="https://socialflylive.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            SOCIALFLY. All Rights Reserved.
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
